import './index.css';
export default function Hero({ title, description, size = '100px'}){
    if(size === 'xl'){ size = '300px '}
    if(size === 'l'){ size = '250px' }
    if(size === 's'){ size = '120px'}
    return(
        <section className="hero" style={{ height: size }}>
            <section className="hero-title-page">
                <h1 className='hero-title-h1'>{ title }</h1>
                <p className='hero-title-p'>{ description }</p>
            </section>
        </section>
    );
}